'use strict';

var _createForOfIteratorHelper = require("/Users/easy/Code/gitcode/clickcloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var visit = require('unist-util-visit');

var nodeToString = require('hast-util-to-string');

var refractor = require('refractor');

module.exports = function (options) {
  options = options || {};
  return function (tree) {
    visit(tree, 'element', visitor);
  };

  function visitor(node, index, parent) {
    if (!parent || parent.tagName !== 'pre' || node.tagName !== 'code') {
      return;
    }

    var lang = getLanguage(node);

    if (lang === null) {
      return;
    }

    var result;

    try {
      parent.properties.className = (parent.properties.className || []).concat('language-' + lang);
      result = refractor.highlight(nodeToString(node), lang);
    } catch (err) {
      if (options.ignoreMissing && /Unknown language/.test(err.message)) {
        return;
      }

      throw err;
    }

    node.children = result;
  }
};

function getLanguage(node) {
  var className = node.properties.className || [];

  var _iterator = _createForOfIteratorHelper(className),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var classListItem = _step.value;

      if (classListItem.slice(0, 9) === 'language-') {
        return classListItem.slice(9).toLowerCase();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}